var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h1-wrapper"},[_c('h1',{staticClass:"hh1",on:{"click":_vm.toggleContent}},[_vm._t("default"),(_vm.hasContent)?_c('span',{staticClass:"toggle-btn"},[_vm._v(" "+_vm._s(_vm.isHidden ? '+' : '-')+" ")]):_vm._e()],2),(_vm.hasContent)?_c('div',{staticClass:"content",class:{ hidden: _vm.isHidden }},[_vm._t("content")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }